(() => {
  if (customElements.get('nova-name-personalization')) return;
  const names = new Map();

  class NovaNamePersonalization extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.form = this.input?.form;
      if (!this.input || !this.form) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const savedName = names.get(this.dataset.productId);
      if (!this.input.value && savedName !== undefined) this.input.value = savedName;
      const rememberAndValidate = () => {
        names.set(this.dataset.productId, this.input.value);
        this.input.setCustomValidity(this.input.value.trim() ? '' : this.dataset.error);
      };
      this.input.addEventListener('input', rememberAndValidate, options);
      this.input.addEventListener('change', () => {
        this.input.value = this.input.value.trim();
        rememberAndValidate();
      }, options);
      this.form.addEventListener('submit', (event) => {
        this.input.value = this.input.value.trim();
        rememberAndValidate();
        if (!this.input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.reportValidity();
        }
      }, { ...options, capture: true });
      rememberAndValidate();
    }

    disconnectedCallback() {
      if (this.input) names.set(this.dataset.productId, this.input.value);
      this.controller?.abort();
    }
  }

  customElements.define('nova-name-personalization', NovaNamePersonalization);
})();
